export const SHOW_START = 'SHOW_START';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';

export const UPDATE_START = 'UPDATE_START';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'UPDATE_FAILURE';

export const PREFIX_PREVIEW_START = 'PREFIX_PREVIEW_START';
export const PREFIX_PREVIEW_SUCCESS = 'PREFIX_PREVIEW_SUCCESS';
export const PREFIX_PREVIEW_FAILURE = 'PREFIX_PREVIEW_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'SYSTEM_FAILURE';
